const messages = {
  ch: {
    message: {
      search: '搜索',
      times: '次',
      more:'更多',
      live: '精彩直播',
      tpl1: {
        menu: {
          info: '我的报名信息',
          language: 'English',
          exit: '退出',
          register: '个人报名',
          paperRegister: '在线投稿', // 个人在线投稿
          teamReg: '团队报名',
          hotelBook: '酒店预订'
        },
        daily: {
          zhuxi: '主席',
          zhuchi: '主持',
          dianping: '点评',
          fanyi: '翻译',
          teacher: '讲者',
          time: '时间',
          theme: '主题',
          speakerType: '发言类型',
          tip: '请输入主题/发言类型/讲者',
          keyWords: '关键词',
          metting: '会议厅'
        }
      },
      tpl3: {
        menu: {
          login: '登录',
          logout: '退出',
          mettingDate: '会议日期',
          reportDate: '现场报道日期',
          registerEndDate: '网上报名截止时间',
          paperEndDate: '征文投稿截止日期',
          daysDistance: '距离会议开幕',
          conferenceS:'距离会议开幕',
          day: '天',
          hours:'时',
          minutes:'分',
          seconds:'秒',
          linkUs: '联系我们',
          org: '单位',
          title: '职称',
          notic: '暂未确定会议开始时间'
        }
      }
    }
  },
  en: {
    message: {
      search: 'Search',
      times: 'Times',
      more: "More",
      live: "Live",
      tpl1: {
        menu: {
          info: 'My Registration',
          language: '简体中文',
          exit: 'Exit',
          register: 'Register',
          paperRegister: 'Submit', // 个人在线投稿
          teamReg: 'Team Registration',
          hotelBook: 'Hotel Reservation'
        },
        daily: {
          zhuxi: 'Chairman',
          zhuchi: 'Host',
          dianping: 'Comment',
          fanyi: 'Interpreter',
          teacher: 'Speaker',
          time: 'Time',
          theme: 'Theme',
          speakerType: 'Speech Type',
          tip: 'Please enter your theme/speech type/speaker',
          keyWords:'Keywords',
          metting: 'Conference Hall'
        }
      },
      tpl3: {
        menu: {
          login: 'Login',
          logout: 'Logout',
          mettingDate: 'Meeting date',
          reportDate: 'Registration date',
          registerEndDate: 'Deadline for registration',
          paperEndDate: 'Papers submission',
          daysDistance: 'The conference will be opened in',
          conferenceS:'Opened in',
          day: 'days',
          hours:'h',
          minutes:'m',
          seconds:'s',
          linkUs: 'Contact Us',
          org: 'Org',
          title: 'Title',
          notic: 'The beginning of the meeting is not determined'
        }
      }
    }
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/commen/translate.config.js